<div class="simple-widget-header" [style.color]="color">
  <ng-content></ng-content>
</div>
